import { OrderSuccess } from '../components/Thankyou/ordersuccess';
import React from 'react';
import { Layout } from '../layout/Layout';
import ReactDOM from 'react-dom';

export default function Privatelabel() {
  return (
      <Layout>
        <OrderSuccess />
      </Layout>
  );
}



